var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmarkOverview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_675",
    "data-name": "Grupo 675",
    transform: "translate(3055 -69)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-checkmark-circle-outline",
    "data-name": "Icon ionic-ios-checkmark-circle-outline",
    transform: "translate(-3055 69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1458",
    "data-name": "Trazado 1458",
    d: "M46.875,9.231A37.65,37.65,0,0,1,73.5,73.5,37.65,37.65,0,0,1,20.252,20.252,37.4,37.4,0,0,1,46.875,9.231m0-5.856a43.5,43.5,0,1,0,43.5,43.5,43.493,43.493,0,0,0-43.5-43.5Z",
    transform: "translate(-3.375 -3.375)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-check-circle",
    "data-name": "Icon feather-check-circle",
    transform: "translate(-3031.361 98.615)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1462",
    "data-name": "Trazado 1462",
    d: "M55.439,6,23.178,38.952,13.5,29.076",
    transform: "translate(-13.5 -6)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkOverview);
export default __webpack_public_path__ + "static/media/checkmark_overview.c1cd74162092bcaa8f28f71c4e7572fa.svg";
export { ForwardRef as ReactComponent };